import React, { useState, useRef, useEffect } from "react";

export { useImageBaseUrl } from "../../context/ImageBaseUrlContext";

export function SabiasQueNY({ icono = "💬", texto = "" }) {
	const [visible, setVisible] = useState(false);
	const [showAbove, setShowAbove] = useState(false);
	const containerRef = useRef(null);
	useEffect(() => {
		if (!visible) return;
		const h = (e) => {
			if (containerRef.current && !containerRef.current.contains(e.target)) setVisible(false);
		};
		document.addEventListener("click", h);
		return () => document.removeEventListener("click", h);
	}, [visible]);
	const toggle = (e) => {
		e.stopPropagation();
		if (!visible && containerRef.current) {
			const rect = containerRef.current.getBoundingClientRect();
			const spaceBelow = window.innerHeight - rect.bottom;
			setShowAbove(spaceBelow < 160 && rect.top > 160);
		}
		setVisible(!visible);
	};
	return (
		<div ref={containerRef} style={{ position: "relative", display: "inline-block" }}>
			<div
				style={{
					width: 32,
					height: 32,
					borderRadius: "50%",
					backgroundColor: "#fff",
					border: "1px solid #ccc",
					boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					cursor: "pointer",
					fontSize: 16,
				}}
				onClick={toggle}
			>
				{icono}
			</div>
			{visible && (
				<div
					style={{
						position: "absolute",
						bottom: showAbove ? "120%" : "auto",
						top: showAbove ? "auto" : "120%",
						left: "50%",
						transform: "translateX(-50%)",
						backgroundColor: "#fffbe6",
						border: "2px solid #f5c400",
						borderRadius: 12,
						padding: "10px 14px",
						fontSize: 12,
						fontFamily: '"Poppins", sans-serif',
						color: "#444",
						width: 250,
						boxShadow: "2px 2px 6px rgba(0, 0, 0, 0.1)",
						zIndex: 10,
						whiteSpace: "normal",
					}}
				>
					{texto}
				</div>
			)}
		</div>
	);
}

export const estiloH3NY = {
	fontFamily: '"Poppins", sans-serif',
	fontSize: 14,
	fontWeight: 700,
	textTransform: "uppercase",
	margin: 0,
};

export const estiloPNY = {
	fontFamily: '"Poppins", sans-serif',
	fontSize: 13,
	color: "#444",
	margin: 0,
	fontWeight: 400,
};

export const BASE_NY = "/images/ny/";
